import { makeStyles } from 'lib/components';

export default makeStyles((theme) => ({
  historicUsageContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    backgroundColor: theme.evPalette.salt[100],
  },
  barChartDiv: {
    maxHeight: '400px',
    border: `1px solid ${theme.evPalette.charcoal[400]}`,
    borderRadius: '4px',
  },
  tooltip: {
    backgroundColor: theme.evPalette.salt[100],
    border: `1px solid ${theme.evPalette.charcoal[300]}`,
    borderRadius: '8px',
    padding: '12px',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    minWidth: '160px',
  },
  tooltipContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: '6px',
  },
  tooltipItem: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '8px',
  },
  tooltipDot: {
    width: '12px',
    height: '12px',
    borderRadius: '50%',
    flexShrink: 0,
  },
}));
